<template>
    <div>
        <dl class="description-list-wrapper">
            <DescriptionItem :label="$t('연결 프로젝트')">
                {{ getTargetProjectText || '-' }}
            </DescriptionItem>

            <DescriptionItem :label="$t('키 이름')">
                {{ detailData.key_name || '-' }}
            </DescriptionItem>
            <DescriptionItem :label="$t('값 타입')">
                <b-badge variant="dark" class="f-90">
                    {{ getValueTypeText }}
                </b-badge>
            </DescriptionItem>

            <DescriptionItem :label="$t('라벨 키')">
                <b-button variant="link" style="padding: 0"
                          @click="openLocaleStringDetail"
                >
                    {{ labelInfo || '-' }}
                </b-button>
            </DescriptionItem>

            <DescriptionItem :label="$t('필수 여부')">
                <b-badge :variant="getIsRequiredText.variant" class="f-90">
                    {{ getIsRequiredText.text }}
                </b-badge>
            </DescriptionItem>

            <DescriptionItem :label="$t('설명')">
                <template v-if="getDescription.type === 'object'">
                    <div v-html="getDescription.value?.[$i18n.locale]"/>
                </template>
                <template v-else>
                    {{ getDescription.value}}
                </template>
            </DescriptionItem>

            <template v-if="detailData.value_type === 'list'">
                <DescriptionItem :label="$t('허용값 목록')">
                    <div class="allowed-values readonly">
                        <div v-if="allowedLoading" class="text-muted">{{ $t('로딩 중...') }}</div>
                        <template v-else>
                            <b-table
                                v-if="allowedValues.length > 0"
                                :items="allowedValues"
                                :fields="allowedFields"
                                responsive
                                fixed
                                small
                                bordered
                                hover
                                head-variant="light"
                                class="mb-0 rounded-sm"
                            />
                            <div v-else class="text-muted">-</div>
                        </template>
                    </div>
                </DescriptionItem>
            </template>

            <div class="row-wrapper">
                <DescriptionItem :label="$t('등록일시')">
                    {{ get_date(detailData.created_at) || '-' }}
                </DescriptionItem>

                <DescriptionItem :label="$t('수정일시')">
                    {{ get_date(detailData.updated_at) || '-' }}
                </DescriptionItem>
            </div>
        </dl>
        <LocaleStringModal ref="localeStringModal"
                           :detail-id="localeStringKey"
        />
    </div>

</template>

<script>
import DescriptionItem from '@shared/components/common/DescriptionItem.vue';
import {
    getDate,
    getTargetProjectText
} from '@shared/components/admin/pages/Management/common-data';
import LocaleStringModal
    from '@shared/components/admin/pages/Management/ProjectSchema/LocaleString/LocaleStringModal.vue';
import {
    allowValuesColumn,
    valueTypeOptions
} from '@shared/components/admin/pages/Management/ProjectSchema/SchemaInput/data';

export default {
    name: 'SchemaInputDetail',
    components: {
        LocaleStringModal,
        DescriptionItem
    },
    props: {
        detailData: {
            type: Object,
            required: true,
            default: () => ({id: null}),
        },
        projects: {
            type: [Array, null],
            default: null,
        },
        allowedValues: {
            type: Array,
            default: () => [],
        }
    },
    data() {
        return {
            localeStringKey: null,
            allowedLoading: false,
        };
    },
    computed: {
        getTargetProjectText() {
            return getTargetProjectText(this.detailData.project_id, this.projects);
        },
        labelInfo() {
            return `${this.detailData.label_key} ( ko: ${this.detailData.label_texts?.ko ?? '-'}, en: ${this.detailData.label_texts?.en ?? '-'}, ca: ${this.detailData.label_texts?.ca ?? '-'} )`;
        },
        getValueTypeText() {
            const target = valueTypeOptions.find((item) => item.value === this.detailData.value_type)?.text;
            if (target) {
                return `${target} (${this.detailData.value_type})`;
            }
            return '-';
        },
        getIsRequiredText() {
            return {
                variant: this.detailData.is_required ? 'success' : 'secondary',
                text: this.detailData.is_required ? this.$t('필수') : this.$t('선택'),
            };
        },
        get_date() {
            return (date) => {
                return getDate(date);
            };
        },
        getDescription(){
            if(!this.detailData.description) return {
                type: 'unknown',
                value: '-'
            };
            let parsed;
            try {
                parsed = JSON.parse(this.detailData.description);
            } catch (e) {
                // JSON 이 아닌 평문 설명은 그대로 보여준다
                return {
                    type: 'string',
                    value: this.detailData.description
                };
            }
            if(typeof parsed === 'string')  {
                return {
                    type: 'string',
                    value: parsed
                };
            }
            else if(parsed && typeof parsed === 'object') {
                return {
                    type: 'object',
                    value: parsed
                };
            }
            return {
                type: 'unknown',
                value: parsed
            };
        },
        allowedFields() {
            return allowValuesColumn;
        }
    },
    methods: {
        openLocaleStringDetail() {
            this.localeStringKey = this.detailData?.label_key;
            this.$refs.localeStringModal.changeMode('readOnly');
            this.$bvModal.show('locale-string-detail-modal');
        },
    },
};
</script>
<style lang="scss" scoped>
.allowed-values.readonly {
    .av-value {
        min-width: 120px;
    }
}
</style>
